<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-dialog v-model="dialogView" fullscreen persistent max-width="100%">
            <v-card>
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialogView = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>ข้อมูลพนักงาน {{ groupName }}</v-toolbar-title>
              </v-toolbar>
              <v-row>
                <v-col cols="6">
                  <v-card-text>
                    <v-container>
                      <v-card-title>
                        <v-text-field
                          v-model="search2"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-card-title>
                      <v-data-table
                        :headers="columnsEmp"
                        :items="dataItemEmp"
                        :search="search2"
                        :items-per-page="10"
                      >
                      </v-data-table>
                    </v-container>
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-text>
                    <v-container>
                      <v-card-title>
                        <v-text-field
                          v-model="search3"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-card-title>
                      <v-data-table
                        :headers="columnsMenu"
                        :items="dataItemMenu"
                        :search="search3"
                        :items-per-page="10"
                      >
                      </v-data-table>
                    </v-container>
                  </v-card-text>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="dialogView = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="search"
                  :items-per-page="50"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_date(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="question"
                      fab
                      small
                      @click.stop="(dialogView = true), getDataEmployee(item)"
                    >
                      <v-icon dark> mdi-account </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู

export default {
  components: {
    'left-menu-admin': adminLeftMenu
  },
  data () {
    return {
      PK: '',
      path: '/system_user_type_group/', // Path Model
      dataReady: true,
      dialogView: false,
      session: this.$session.getAll(),
      search: '',
      search2: '',
      search3: '',
      groupName: '',
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'กลุ่มผู้ใช้งาน',
          disabled: true,
          href: 'HRM/System/UserTypeGroup'
        }
      ],
      columns: [
        { text: 'ชื่อกลุ่ม', value: 'userTypeGroupName' },
        { text: 'รายละเอียดกลุ่ม', value: 'userTypeGroupDetail' },
        { text: 'ยอดรวม / คน', value: 'total_uer_assign' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        {
          text: 'รายชื่อพนักงาน',
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ],
      columnsEmp: [
        { text: 'รหัสพนักงาน', value: 'empCode', align: 'center' },
        { text: 'ชื่อ-นามสกุล', value: 'empFull_NameTH' },
        { text: 'ประเภทพนักงาน', value: 'positionTypeName' },
        { text: 'ตำแหน่ง', value: 'positionName' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'บริษัท', value: 'masCompanyName' }
      ],
      columnsMenu: [
        { text: 'หัวข้อ', value: 'menuNameHeader' },
        { text: 'ชื่อ', value: 'menuName' },
        { text: 'ประเภท', value: 'menuType' }
      ],
      dataItem: [],
      dataItemEmp: [],
      dataItemMenu: []
    }
  },
  async mounted () {
    this.dataReady = false
    await this.getData()
  },
  methods: {
    async getData () {
      let dataItem = []
      dataItem = await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "get", {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
      this.dataItem = (dataItem.data.length > 0) ? dataItem.data : []
      this.dataReady = true
    },
    async getDataEmployee (item) {
      this.groupName = item.userTypeGroupName
      let dataItemEmp = []
      dataItemEmp = await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_user/get?userTypeGroup=' +
            item.userTypeGroupName,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
      this.dataItemEmp = (dataItemEmp.data.length > 0) ? dataItemEmp.data : []

      let dataItemMenu = []
      dataItemMenu = await axios
        .get(
          this.DNS_IP + '/system_menu/get?userTypeGroup=' + item.userTypeGroupName,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
      console.log('dataItemMenu', dataItemMenu)
      this.dataItemMenu = (dataItemMenu.data.length > 0) ? dataItemMenu.data : []
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/System/UserTypeGroup.vue